"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const datasetContext_1 = __importDefault(require("./datasetContext"));
const datasetReducer_1 = __importDefault(require("./datasetReducer"));
const axios_1 = __importDefault(require("axios"));
const DatasetState = ({ children }) => {
    const initialState = {
        jsonDataByCategory: [],
        jsonDataByIdList: [],
        jsonDataCategory: "",
        getJsonDataByCategory: {},
        getJsonDataByIdList: {},
        removeDatasetData: {},
    };
    const [state, dispatch] = (0, react_1.useReducer)(datasetReducer_1.default, initialState);
    const getJsonDataByCategory = (category) => {
        axios_1.default.get(`/api/load-files/${category}`).then((res) => {
            dispatch({
                type: "GET_JSON_DATA_LIST_BY_CATEGORY",
                payload: { jsonDataCategory: category, jsonDataByCategory: res.data },
            });
        });
    };
    const getJsonDataByIdList = (idList) => {
        let jsonDataArray = [];
        let promises = [];
        for (const element of idList) {
            promises.push(axios_1.default.get(`/api/load-file/${element}`).then((res) => {
                jsonDataArray.push(res.data);
            }));
        }
        Promise.all(promises).then(() => {
            dispatch({
                type: "GET_JSON_DATA_LIST_BY_ID_LIST",
                payload: jsonDataArray,
            });
        });
    };
    const removeDatasetData = () => {
        dispatch({ type: "REMOVE_CHART_DATA", payload: initialState });
    };
    return (react_1.default.createElement(datasetContext_1.default.Provider, { value: {
            jsonDataByCategory: state.jsonDataByCategory,
            jsonDataByIdList: state.jsonDataByIdList,
            jsonDataCategory: state.jsonDataCategory,
            getJsonDataByCategory: getJsonDataByCategory,
            getJsonDataByIdList: getJsonDataByIdList,
            removeDatasetData: removeDatasetData,
        } }, children));
};
exports.default = DatasetState;
